export enum TableInputFieldVariant {
  Textarea = 'textarea',
  Input = 'input',
  InputNumber = 'input[number]',
  Checkbox = 'checkbox',
  Select = 'select',
  Datepicker = 'datepicker',
}
